import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'dm-notification-bar',
  templateUrl: './notification-bar.component.html',
  styleUrls: ['./notification-bar.component.css']
})
export class NotificationBarComponent implements OnInit {

    notifications: any[];

    isOpen = false;
    notifiationContent = '';
    isVisible = false;

    constructor(private router: Router,
                private notificationService: NotificationService) {
    }

    ngOnInit() {
        const url = this.router.url;
        this.notificationService.get()
            .subscribe(results => {
                this.notifications = results;
                if (this.notifications) {
                    this.loadNotifiation(url);
                }
            });
    }

    toggleCollapse() {
        this.isOpen = !this.isOpen;
    }
    private loadNotifiation(key: string = ''): void {
        const notificatioin = this.notifications.find(x => key.includes(x.url));
        if (notificatioin) {
            this.notifiationContent = notificatioin.description;
            this.isVisible = true;
        } else {
            this.isVisible = false;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/notification-bar/notification-bar.component.ts